import {React,useState} from 'react';
import '../Central.css';
import KeyValueGrid from '../KeyValueGrid';
import Navbar from './Navbar';
import { Routes,Route, Router } from 'react-router-dom';


const Central = () => {
    const[inputString,setinputString]=useState("")
    const[outputString,setoutputString]=useState("Click on Generate to encrypt your message")
    const[isGenerated,setisGenerated]=useState(false)
    const[isValid,setisValid]=useState(true)
    const[displayValue,setdisplayValue]=useState([])
    
    const KeyValue = new Map();
    const keys=['.',' ',',','?','0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
    let value=['.',' ',',','?']
    let ans=[]
    let ansString=""

    function generateAnswer()
    {
      
      const inputarray = Array.from(inputString)
      // value=[...value]
      // map1.set('c', 3);
      // console.log(map1.get('c'));
      while(value.length!==40)
      {
        // const curInt=Math.floor(Math.random()* 75)+48;
        // const curChar=String.fromCharCode(curInt);
        const curInt=Math.floor(Math.random()* 75)+48;
        let curChar
        if(curInt>=48&&curInt<=57||curInt>=97&&curInt<=122)
        {
          curChar=String.fromCharCode(curInt);
        }
        else
        continue;
        
        if(value.includes(curChar)===true)
        {
          continue
        }
        else
        {
          value.push(curChar)
        }
        
      }     
      for(let i=0;i<40;++i)
      {
    
        KeyValue.set(keys[i],value[i])
      }
    
     
      for(let j=0;j<inputarray.length;++j)
      {
      ansString+=KeyValue.get(inputarray[j]);
      }
    
      
   if(ansString.includes("undefined")===true)
   {
    setoutputString("Invalid input the text must only contain . , ? a-z and A-Z")
    setdisplayValue([])
    setisGenerated(false)
   }
   else if(ansString==="")
   {
    setoutputString("Please type something in the above text area!")
    setdisplayValue([])
    setisGenerated(false)
   }
   else{
    setoutputString(ansString)
    setdisplayValue(value)
    setisGenerated(true)
   }
  
    }
    
    function changeInput(event)
    {
      // console.log(event.target.value)
      setinputString((prev) =>{ return event.target.value.toLowerCase() })
    }

    function KeyHandl(e)
    {
      if(e.key=='Enter')
      return generateAnswer()
    }

  return (
    
     <>
    <div className="App">
    
      <div className='input-box'>
      <h1 className='input-heading'><p>Enter the text that <span>you want to encrypt!!</span></p></h1>
        <textarea type='text' onChange={changeInput} onKeyPress={KeyHandl} placeholder="Allowed Characters are . , ? 0-9, a-z and A-Z"></textarea>
      </div> 
      <div className='ans-string'><p>{isGenerated&&<p>Your <span>encrypted</span> message is-</p>}{outputString}</p></div>
     

      <div className='btn'>
      <div>
        <button className='generate-button' onClick={generateAnswer} >Generate</button>
        <a href='/about'><button className='mobile-button' >About Me</button></a>
      </div>
      </div>

      {isGenerated&&<h1 className='first-heading'><p><span>Key</span> Value pairs for this encrypted message!!!</p></h1>}
      
<div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead><tr>
      {isGenerated&&keys.map((item,i) =>{if(i>=4&&i<10)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=4&&i<10)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>

   <div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead ><tr>
      {isGenerated&&keys.map((item,i) =>{if(i>=10&&i<16)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=10&&i<16)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>
   
   
   <div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead ><tr> 
      {isGenerated&&keys.map((item,i) =>{if(i>=16&&i<22)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=16&&i<22)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>
  
  
  <div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead ><tr> 
      {isGenerated&&keys.map((item,i) =>{if(i>=22&&i<28)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=22&&i<28)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>
  
  
  <div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead ><tr> 
      {isGenerated&&keys.map((item,i) =>{if(i>=28&&i<34)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=28&&i<34)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>
  
  
  <div className={isGenerated?'landing-content':null}> 
   <table className='table'>
   <thead ><tr> 
      {isGenerated&&keys.map((item,i) =>{if(i>=34&&i<40)return <th>{item}</th>})}</tr></thead><tbody><tr>
   {isGenerated&&keys.map((item,i) =>{if(i>=34&&i<40)return <td>{displayValue[i]}</td>})}</tr></tbody></table></div>
   
   
    </div>
    </>
  )
}

export default Central
